import FormField from '@sportnet/ui/lib/FormField/redux-form';
import * as React from 'react';
import { Field } from 'redux-form';
import { FormField as IFormSegmentElement } from '../../../api';

interface OwnProps {
  data: IFormSegmentElement;
  name: string;
}

const CheckboxFormElement: React.FC<OwnProps> = ({ data, name }) => (
  <Field
    name={name}
    component={FormField}
    label={data.label}
    type="checkbox"
    disabled
  />
);

export default CheckboxFormElement;
